var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-border"},[_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.data.icon))]),_c('div',[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.data.title))]),_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.data.value))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }